<template>
  <div>
    <div class="breadcrumb">
      <slot name="header">
        <h1>{{ page }}</h1>
      </slot>
    </div>
  </div>
</template>
<script>
export default {
  props: ["page", "folder"],
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/breadcumb.vue